(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.controller('ClicktimeProtectionListManagementController', ["$scope", "$q", "tablePaginationHelper", "defaultListConverter", "modals", "columnsHelper", "clicktimeProtectionDao", function ($scope, $q, tablePaginationHelper, defaultListConverter, modals, columnsHelper, clicktimeProtectionDao) {
        $scope.initializing = true;
        var listMap = [
            'blacklist',
            'whitelist',
            'ignorelist'
        ];
        $q.allSettled([
            clicktimeProtectionDao.list(),
            clicktimeProtectionDao.listitem()
        ]).then(function (responses) {
            console.log('responses:', responses);
        });
        $scope.options = {
            columns: [
                {
                    id: 'listid',
                    hidden: true
                },
                {
                    id: 'listitemid',
                    hidden: true,
                    primary: true
                },
                {
                    id: 'created_by',
                    text: 'Created By'
                },
                {
                    id: 'listitemname',
                    text: 'Domain'
                },
                {
                    id: 'listname',
                    text: 'List Name',
                    converter: 'exceptionsRuleWordingConverter'
                },
                {
                    id: 'created_at',
                    text: 'Created At',
                    converter: 'doubleLineDate'
                },
                {
                    id: 'actions',
                    text: false,
                    converter: 'actionsConverter'
                }
            ],
            options: {
                checkboxes: true,
                defaultOrdering: {
                    columnName: 'listitemid',
                    order: 'desc'
                }
            }
        };
        function listItemModal(isEdit, listitemData) {
            var originData = {};
            if (isEdit && listitemData && listitemData.entityData) {
                originData = listitemData.entityData;
            }
            var listitemParams = [
                {
                    type: 'widget',
                    sentence: 'Add a new domain to one of the following lists: Allow-List, Block-List and Ignore-List. ' + 'The lists are used by the ClickTime Protection engine. Only exact domain names are supported.',
                    class: 'about-add-domain'
                },
                {
                    id: 'listitemname',
                    label: 'Domain',
                    type: 'string',
                    validation: {
                        required: true,
                        valid: true
                    },
                    data: isEdit ? originData.listitemname : '',
                    labelClass: 'custom-width',
                    paramClass: 'custom-width',
                    placeholder: 'Example patterns: xxxx.com, xxxx.net ...',
                    settings: {
                        errTipContent: 'Not valid Domain',
                        parentElement: '.param-control',
                        successTipContent: 'Valid Domain',
                        validation: true,
                        validationType: 'domain',
                        validationOnTyping: true,
                        status: ''
                    }
                },
                {
                    id: 'listid',
                    label: 'List Name',
                    type: 'selector-v2',
                    variants: [
                        {
                            id: '0',
                            label: 'Allow-List',
                            tooltip: 'Domains in this list would be allowed automatically (click would be redirected to the original URL)'
                        },
                        {
                            id: '1',
                            label: 'Block-List',
                            tooltip: 'Domains in this list would be blocked (a block page would be presented when clicked). The ClickTime protection policy determines if the user is allowed to proceed'
                        },
                        {
                            id: '2',
                            label: 'Ignore-List',
                            tooltip: 'Links for domains in the list would not be rewritten'
                        }
                    ],
                    data: isEdit ? originData.listid : '0',
                    labelClass: 'custom-width',
                    paramClass: 'custom-width'
                }
            ];
            var modalTitle = 'Add new domain';
            if (isEdit) {
                modalTitle = 'Edit domain';
            }
            modals.params([{
                    lastPage: true,
                    params: listitemParams
                }], modalTitle, 'md', { windowClass: 'clicktime-protection-list-management-modal-container' }).then(function (data) {
                if (data && !_(data).isEmpty()) {
                    if (isEdit) {
                        return clicktimeProtectionDao.updateListitem(originData.listitemid, [data]);
                    }
                    return clicktimeProtectionDao.addListitem([data]);
                }
            }).then(function () {
                $scope.tableHelper.clearSelection();
                $scope.tableHelper.reload();
            });
        }
        $scope.tableOptions = {
            disableTop: true,
            orderDisplayMode: 'highlight-column',
            asDivs: true,
            infinite: true,
            showWorkingIndicator: true,
            workingIndicatorDisableGui: false,
            saveState: true,
            headerOptions: { enum: { multiple: true } },
            pagination: {
                pageSize: 10,
                ordering: {}
            },
            dropdownHeader: true,
            actions: [
                {
                    label: 'Delete',
                    display: 'button',
                    class: 'btn-action',
                    active: function () {
                        return $scope.tableHelper.getSelectedIds().length > 0;
                    },
                    execute: function () {
                        var message, title = 'Delete Listitem', selectedIds = $scope.tableHelper.getSelectedIds();
                        if (!selectedIds.length) {
                            return;
                        }
                        if (selectedIds.length === 1) {
                            message = 'Are you sure you want to delete selected item?';
                        } else {
                            message = 'Are you sure you want to delete ' + selectedIds.length + ' selected items?';
                            title += 's';
                        }
                        modals.confirm({
                            message: message,
                            title: title,
                            okText: 'Delete'
                        }).then(function () {
                            return clicktimeProtectionDao.removeListitems(selectedIds.join(','));
                        }).then(function () {
                            $scope.tableHelper.clearSelection();
                            $scope.tableHelper.reload();
                        });
                    }
                },
                {
                    label: 'New',
                    display: 'button',
                    class: 'btn-action',
                    execute: function () {
                        listItemModal();
                    }
                }
            ]
        };
        $scope.tableHelper = tablePaginationHelper($scope, $scope.tableOptions, $scope.options, function (args) {
            var q = clicktimeProtectionDao.listitem();
            var params;
            if (args.columnsFilters) {
                params = columnsHelper.filtersToParams(args.columnsFilters);
                params.resolve = true;
                q.params(params);
            }
            return q.pagination(args.offset, args.limit).filter(args.filter).order(args.ordering.columnName, args.ordering.order).converter(defaultListConverter, function (preFetches) {
                return {
                    columns: $scope.options.columns,
                    converters: {
                        actionsConverter: function (text, columnId, columnsMap, args) {
                            var result = '#' + JSON.stringify({
                                display: 'text',
                                'class': 'restore-action-link fa fa-pencil',
                                tooltip: 'Edit',
                                clickEvent: {
                                    name: 'edit-listitem',
                                    entityId: columnsMap.listitemid,
                                    entityData: columnsMap
                                }
                            });
                            return result;
                        },
                        doubleLineDate: function (text) {
                            var time = moment.utc(text).local();
                            return '#' + JSON.stringify({
                                'display': 'text',
                                'class': 'dbl-line-date-time',
                                'text': time.format('HH:mm:ss')
                            }) + '#' + JSON.stringify({
                                'display': 'text',
                                'class': 'dbl-line-date-date',
                                'text': time.format('YYYY-MM-DD')
                            });
                        }
                    }
                };
            });
        }, function (tableModel) {
            $scope.initializing = false;
            $scope.tableModel = tableModel;
            $scope.tableOptions.infoText = 'Total list items found: ' + $scope.tableHelper.getTotal();
        });
        $scope.$on('edit-listitem', function (event, data) {
            listItemModal(true, data);
        });
    }]);
}());